import { AuthUserContext } from '@app/contexts/AuthUserContext';
import { useContext } from 'react';
export var useUser = function useUser() {
  return useContext(AuthUserContext);
};